import React, { useState } from "react";
import { useAuth } from "../../lib/auth";
import { useNavigate, Link } from "react-router-dom";
import { toast, Toaster } from "sonner";
import api, { formatApiError } from "../../lib/api";

export default function AgenziaLogin() {
  const { loginAgency } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [forgotOpen, setForgotOpen] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");
  const [forgotSent, setForgotSent] = useState(false);
  const [forgotLoading, setForgotLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const r = await loginAgency(email, password);
    setLoading(false);
    if (r.ok) {
      toast.success("Bentornati.");
      nav(r.must_change_password ? "/area-agenzie/primo-accesso" : "/area-agenzie");
    }
    else toast.error(r.error);
  };

  const sendReset = async (e) => {
    e.preventDefault();
    if (!forgotEmail.trim()) { toast.error("Inserisci la tua email"); return; }
    setForgotLoading(true);
    try {
      await api.post("/agency/auth/password-reset/request", { email: forgotEmail.trim() });
      setForgotSent(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Errore invio email");
    } finally { setForgotLoading(false); }
  };

  return (
    <div className="min-h-screen paper-bg flex" data-testid="agenzia-login-page">
      <Toaster position="top-right" richColors />
      <div className="hidden md:flex md:w-1/2 border-r border-[#E6E4E0] p-16 flex-col justify-between paper-alt-bg">
        <Link to="/" className="leading-none">
          <div className="font-serif text-xl text-[#7D2E3F] tracking-[0.14em]">PRONTO ALLA VENDITA</div>
          <div className="label-uppercase mt-1 text-[#5C5657]">by RX CASA</div>
        </Link>
        <div>
          <div className="label-uppercase mb-4">Area riservata</div>
          <h1 className="font-serif text-5xl leading-tight max-w-md">Area Agenzie Partner</h1>
          <p className="text-[#5C5657] mt-6 max-w-md">Uno spazio dedicato alle agenzie della rete RX CASA per gestire i propri immobili in Galleria, le richieste in arrivo e il proprio profilo.</p>
        </div>
        <div className="text-xs text-[#5C5657]">L'esito del Protocollo e il Fascicolo restano attribuzione esclusiva del garante del Protocollo RX CASA.</div>
      </div>
      <div className="flex-1 flex items-center justify-center p-8">
        {!forgotOpen ? (
          <form onSubmit={submit} className="w-full max-w-md">
            <div className="label-uppercase mb-4">Accedi</div>
            <h2 className="font-serif text-4xl mb-2">Accedi all'Area Agenzie</h2>
            <p className="text-sm text-[#5C5657] mb-10">Uso riservato alle agenzie partner della rete RX CASA.</p>
            <div className="space-y-6">
              <div>
                <label className="label-uppercase">Email</label>
                <input required type="email" data-testid="agenzia-login-email" value={email} onChange={(e) => setEmail(e.target.value)} className="editorial-input" autoFocus />
              </div>
              <div>
                <label className="label-uppercase">Password</label>
                <input required type="password" data-testid="agenzia-login-password" value={password} onChange={(e) => setPassword(e.target.value)} className="editorial-input" />
              </div>
              <button type="submit" disabled={loading} data-testid="agenzia-login-submit" className="btn-primary w-full">{loading ? "Accesso…" : "Accedi"}</button>
              <button type="button" data-testid="agenzia-forgot-link"
                      onClick={() => { setForgotEmail(email); setForgotOpen(true); setForgotSent(false); }}
                      className="block w-full text-xs text-center text-[#7D2E3F] hover:underline">
                Password dimenticata?
              </button>
              <Link to="/" className="block text-xs text-center text-[#5C5657] hover:text-[#7D2E3F]">← Torna al sito pubblico</Link>
            </div>
          </form>
        ) : (
          <div className="w-full max-w-md" data-testid="agenzia-forgot-panel">
            <div className="label-uppercase mb-4">Recupero credenziali</div>
            <h2 className="font-serif text-4xl mb-2">Password dimenticata</h2>
            {!forgotSent ? (
              <>
                <p className="text-sm text-[#5C5657] mb-10">Inserisci l&apos;email del tuo account. Se registrata, riceverai un link per reimpostare la password (valido 60 minuti).</p>
                <form onSubmit={sendReset} className="space-y-6">
                  <div>
                    <label className="label-uppercase">Email</label>
                    <input required type="email" data-testid="agenzia-forgot-email"
                           value={forgotEmail} onChange={(e) => setForgotEmail(e.target.value)}
                           className="editorial-input" autoFocus />
                  </div>
                  <button type="submit" disabled={forgotLoading} data-testid="agenzia-forgot-submit" className="btn-primary w-full">
                    {forgotLoading ? "Invio…" : "Invia link di reset"}
                  </button>
                  <button type="button" onClick={() => setForgotOpen(false)}
                          className="block w-full text-xs text-center text-[#5C5657] hover:text-[#7D2E3F]">
                    ← Torna al login
                  </button>
                </form>
              </>
            ) : (
              <div className="border border-[#E6E4E0] bg-white p-6" data-testid="agenzia-forgot-sent">
                <div className="label-uppercase text-[#7D2E3F] mb-2">Controlla la tua casella</div>
                <p className="text-sm text-[#3A3D42] leading-relaxed">
                  Se l&apos;email <strong>{forgotEmail}</strong> è registrata come agente Area Agenzie, entro pochi minuti riceverai un messaggio con il link di reset. Il link è valido 60 minuti e utilizzabile una sola volta.
                </p>
                <button onClick={() => { setForgotOpen(false); setForgotSent(false); }}
                        className="btn-primary mt-6 w-full">Torna al login</button>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

